import {
	GET_FINANCIALSTATEMENT_BY_ID,
	CLEAR_FINANCIALSTATEMENT_BY_ID,
	UPDATE_FINANCIALSTATEMENT_BY_ID
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export function financialStatementByIdReducer(state = initialstate.financialStatementsById, action) {
	switch (action.type) {
		case GET_FINANCIALSTATEMENT_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {
					...state,
					financialStatement: {
						...state.financialStatement,
						...action.response
					}
				};
			}
			return state;

		case CLEAR_FINANCIALSTATEMENT_BY_ID:
			return {
				...state,
				financialStatement: {}
			};
		case UPDATE_FINANCIALSTATEMENT_BY_ID:
			return {
				...state,
				financialStatement: action.data
			};
		default:
			return state;
	}
}
